import { TableRow, TableCell, Tooltip, IconButton } from "@mui/material";
import React from "react";
import { IXSifterCreateSavedQueryResponse } from "../../types/XSifterQueries";
import EditNoteIcon from '@mui/icons-material/EditNote';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LaunchIcon from '@mui/icons-material/Launch';
import { Link } from "react-router-dom";
import './SavedQueryRow.css';
import { formatNumberString, formatIsoDate } from "../../types/FormattingHelper";
import ClearIcon from '@mui/icons-material/Clear';

interface ISavedQueryRowProps {
    item: IXSifterCreateSavedQueryResponse,
    onDuplicateItem: (id: string) => void;
    onDeleteQuery: (id: string) => void;
}

const SavedQueryRow: React.FC<ISavedQueryRowProps> = (props: ISavedQueryRowProps) => {
    let updatedDate = formatIsoDate(props.item.lastUpdatedTimestamp);
    let formattedEstimateCount = formatNumberString(props.item.lastEstimateCount);
    let formattedFetchedCount = props.item.fetchInProgress ? "(in progress)" :
        (props.item.totalFetchedCount === undefined) ? "(not downloaded)" : Intl.NumberFormat("en-US").format(props.item.totalFetchedCount ?? 0);
    if (props.item.wasCancelled)
        formattedFetchedCount = "(cancelled)";

    let fetchCountDisplay = props.item.dtArchiveUrl ?
        <Tooltip title="View in DiscoverText">
            <a href={props.item.dtArchiveUrl} target='_blank' rel="noreferrer">{formattedFetchedCount}</a>
        </Tooltip>
        : <>{formattedFetchedCount}</>;

    let canDuplicate = !props.item.fetchInProgress;
    let canEdit = !props.item.fetchInProgress && props.item.totalFetchedCount === undefined;

    return (
        <TableRow key={props.item.savedQueryId}>
            <TableCell>{updatedDate}</TableCell>
            <TableCell>
                {canEdit ? (
                    <Tooltip title="Edit query">
                        <Link to={`/app/query?queryId=${props.item.savedQueryId}`}>{props.item.title}</Link>
                    </Tooltip>
                ) : props.item.title}
            </TableCell>
            <TableCell>{formattedEstimateCount}</TableCell>
            <TableCell>{fetchCountDisplay}</TableCell>
            <TableCell>
                {canDuplicate ? (<Tooltip title="Re-use query">
                    <IconButton onClick={() => props.onDuplicateItem(props.item.savedQueryId)} className="x-hover-blue">
                        <ContentCopyIcon />
                    </IconButton>
                </Tooltip>) : (<Tooltip title="Cannot re-use query while download is in progress">
                    <span>
                        <IconButton disabled={true}>
                            <ContentCopyIcon />
                        </IconButton>
                    </span>
                </Tooltip>)
                }
                <Tooltip title="Delete query">
                    <IconButton className="x-hover-red">
                        <ClearIcon onClick={() => props.onDeleteQuery(props.item.savedQueryId)} />
                    </IconButton>
                </Tooltip>
            </TableCell>
        </TableRow>
    );
};

export default SavedQueryRow;